const AnimatedSlide = ({ children, direction, animationType, index }) => {
    if (!direction || !animationType) return null;

    return (
        <div
            key={`${animationType}-${index}`}
            className={`slide_wrapper ${
            animationType === 'enter'
                ? `slide_absolute slide_enter_${direction}`
                : `slide_exit_${direction}`
            }`}
        >
            {children}
        </div>
    );
};
  
export default AnimatedSlide;